
import React, { useEffect, useState } from "react";


export const FilterContext = React.createContext(null);

/**
 * Provider component to wrap parts of the app that need access
 * to the group filter state.
 *
 * Persists the filter state in `localStorage` so it survives page reloads.
 * @memberof module:providers
 * @function
 * @name FilterProvider
 * @param {Object} props
 * @param {React.ReactNode} props.children - The components that consume this context.
 * @returns {JSX.Element} The provider wrapping the children.
 */
export const FilterProvider = ({ children }) => {
    const [groupFilter, setGroupFilter] = useState(() => {
      try {
        const stored = localStorage.getItem("groupFilter");
        return stored ? JSON.parse(stored) : [];
      } catch (e) {
        //console.error("Failed to parse groupFilter from localStorage", e);
        return [];
      }
    });
  
    useEffect(() => {
      localStorage.setItem("groupFilter", JSON.stringify(groupFilter));
    }, [groupFilter]);
  
    return (
      <FilterContext.Provider value={{ groupFilter, setGroupFilter }}>
        {children}
      </FilterContext.Provider>
    );
  };
